import { createGlobalStyle } from "styled-components";

// Scopes FullBleedPageStyles; keeps the selector and the JSX attribute in sync.
export const PAGE_MARKER = "nrt-provider-config-tool";

// Full-bleed this page: the shell's pageContent box caps (max-width), centres
// (margin auto) and shrink-wraps (display table), so all three need overriding.
// `!important` is required — the shell sets them via an inline `style` prop.
export const FullBleedPageStyles = createGlobalStyle`
  [data-testid="cc-page-content"]:has([data-page="${PAGE_MARKER}"]) {
    display: block !important;
    max-width: none !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
`;
